import { useCurrentAccountContext } from '@retailer-platform/dashboard/utils'
import { clientEnv } from '@retailer-platform/dashboard/env'
import { FeatureToggle } from '../../../access-control/featureToggles'

export const useIsLocaleSelectorEnabled = () => {
  const currentAccountContext = useCurrentAccountContext()

  const isLocaleSelectorEnabled =
    !!currentAccountContext?.account?.featureToggles?.find(
      feature => feature.name === FeatureToggle.localeSelector
    ) ||
    clientEnv.PUBLIC_CLIENT_ENVIRONMENT === 'local' ||
    clientEnv.PUBLIC_CLIENT_ENVIRONMENT === 'staging'

  return isLocaleSelectorEnabled
}
